// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3xmKU","additionalInfo":"AgreementModal_additionalInfo__3PpDe"};